import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { testimonials, stats } from '@/mocks/shows';
import { get_form_url } from '@/hooks/useFormUrl';

const faqs = [
  {
    q: '星辰影院需要注册才能观看吗？',
    a: '不需要！星辰影院所有综艺节目完全免费，无需注册登录即可在线观看。我们致力于为用户提供最便捷的观影体验。',
  },
  {
    q: '综艺节目的更新频率是怎样的？',
    a: '热门综艺通常会在首播后2-4小时内同步更新到星辰影院。我们会紧跟各大卫视和视频平台的播出节奏，确保您不会错过任何精彩内容。',
  },
  {
    q: '星辰影院的画质如何？',
    a: '我们提供720P、1080P和4K多种清晰度选择，默认播放高清画质。所有片源均经过专业转码优化，确保流畅播放不卡顿。',
  },
  {
    q: '可以在手机上观看吗？',
    a: '当然可以！星辰影院支持PC、平板和手机全平台观看。无论是在家还是在外，随时随地享受综艺乐趣。',
  },
  {
    q: '为什么有些节目搜索不到？',
    a: '我们持续扩充内容库，如果您想看的节目暂时没有，可以联系客服反馈，我们会尽快安排上线。同时建议您浏览我们的分类页面，可能发现更多惊喜。',
  },
  {
    q: '星辰影院有广告吗？',
    a: '星辰影院坚持用户体验优先，播放全程无贴片广告、无弹窗广告，让您沉浸式享受综艺乐趣。',
  },
];

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="pt-16 md:pt-18">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <h1 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-6 text-center">
              关于星辰影院
            </h1>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 text-center max-w-2xl mx-auto">
              星辰影院成立于2020年，是国内领先的综艺节目在线观看平台。我们汇聚了全网最新、最热、最全的综艺节目资源，涵盖真人秀、搞笑综艺、音乐竞技、访谈节目、美食旅行等八大分类，致力于为华语观众提供一站式的综艺观影体验。
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-12">
              <div className="p-6 rounded-xl bg-background-100 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-eye-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-800 mb-2">我们的使命</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  让每一位综艺爱好者都能轻松、免费地观看到最优质的综艺内容，享受纯粹的娱乐体验。
                </p>
              </div>
              <div className="p-6 rounded-xl bg-background-100 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-rocket-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-800 mb-2">核心优势</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  极速更新、高清画质、无广告播放、全平台支持，用技术和服务打造极致的观影体验。
                </p>
              </div>
              <div className="p-6 rounded-xl bg-background-100 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-heart-line text-2xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-800 mb-2">用户至上</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  以用户需求为导向，持续优化内容推荐和播放体验，做最懂综艺观众的平台。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-8 text-center">
              品牌口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {testimonials.map((item) => (
                <div key={item.id} className="p-5 md:p-6 rounded-xl bg-background-50">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-primary-500 text-sm"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "{item.content}"
                  </p>
                  <div className="flex items-center gap-3">
                    <img src={item.avatar} alt={item.name} className="w-10 h-10 rounded-full object-cover" />
                    <span className="text-sm font-medium text-foreground-800">{item.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-8 text-center">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              <div className="p-6 rounded-xl bg-background-100">
                <h3 className="font-heading text-lg text-foreground-800 mb-4">联系方式</h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">电子邮箱</p>
                      <p className="text-sm text-foreground-500">contact@xingchencinema.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-phone-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">客服电话</p>
                      <p className="text-sm text-foreground-500">400-888-6688</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">公司地址</p>
                      <p className="text-sm text-foreground-500">北京市朝阳区建国路88号星辰大厦15层</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-time-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">工作时间</p>
                      <p className="text-sm text-foreground-500">周一至周日 9:00 - 21:00</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-xl bg-background-100">
                <h3 className="font-heading text-lg text-foreground-800 mb-4">在线留言</h3>
                <form
                  id="contact-form"
                  data-readdy-form
                  className="space-y-4"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const honeypot = (form.querySelector('input[name="phone_alt"]') as HTMLInputElement)?.value.trim();
                    if (honeypot) {
                      const msgEl = document.getElementById('contact-form-msg');
                      if (msgEl) { msgEl.textContent = '留言已提交，我们会尽快回复！'; msgEl.className = 'text-sm text-secondary-600 mt-3 text-center'; }
                      form.reset();
                      return;
                    }
                    const formUrl = await get_form_url('星辰影院联系表单');
                    if (!formUrl) {
                      const msgEl = document.getElementById('contact-form-msg');
                      if (msgEl) { msgEl.textContent = '提交失败，请稍后重试'; msgEl.className = 'text-sm text-accent-600 mt-3 text-center'; }
                      return;
                    }
                    try {
                      const formData = new FormData(form);
                      const res = await fetch(formUrl, { method: 'POST', body: formData });
                      const text = await res.text();
                      let serverMsg = '';
                      try { const p = JSON.parse(text); serverMsg = p?.meta?.message || p?.message || ''; } catch (_e) { /* ignore parse error */ }
                      const msgEl = document.getElementById('contact-form-msg');
                      if (res.ok && (!serverMsg || !serverMsg.includes('spam'))) {
                        if (msgEl) { msgEl.textContent = '感谢您的留言，我们会尽快回复！'; msgEl.className = 'text-sm text-secondary-600 mt-3 text-center'; }
                        form.reset();
                      } else {
                        if (msgEl) { msgEl.textContent = serverMsg || '提交失败，请稍后重试'; msgEl.className = 'text-sm text-accent-600 mt-3 text-center'; }
                      }
                    } catch {
                      const msgEl = document.getElementById('contact-form-msg');
                      if (msgEl) { msgEl.textContent = '网络错误，请稍后重试'; msgEl.className = 'text-sm text-accent-600 mt-3 text-center'; }
                    }
                  }}
                >
                  <div>
                    <label htmlFor="cf-name" className="block text-sm font-medium text-foreground-700 mb-1">姓名</label>
                    <input
                      id="cf-name"
                      name="name"
                      type="text"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 placeholder-foreground-400 outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="cf-email" className="block text-sm font-medium text-foreground-700 mb-1">邮箱</label>
                    <input
                      id="cf-email"
                      name="email"
                      type="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 placeholder-foreground-400 outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="cf-message" className="block text-sm font-medium text-foreground-700 mb-1">留言内容</label>
                    <textarea
                      id="cf-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 placeholder-foreground-400 outline-none focus:border-primary-400 transition-colors resize-none"
                      placeholder="请输入您的留言内容（500字以内）"
                    ></textarea>
                  </div>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="form-honeypot"
                  />
                  <button
                    type="submit"
                    className="w-full py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    提交留言
                  </button>
                  <div id="contact-form-msg"></div>
                </form>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-8 text-center">
              常见问题
            </h2>
            <div className="space-y-3">
              {faqs.map((faq, idx) => (
                <details key={idx} className="group rounded-xl bg-background-50 overflow-hidden">
                  <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                    <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                      {faq.q}
                    </span>
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 group-open:rotate-180 transition-transform">
                      <i className="ri-arrow-down-s-line text-foreground-500"></i>
                    </div>
                  </summary>
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "关于星辰影院",
          "description": "星辰影院是国内领先的综艺节目在线观看平台，汇聚全网最新最热最全的综艺节目资源。",
          "url": "https://www.xingchencinema.com/about",
          "publisher": {
            "@type": "Organization",
            "name": "星辰影院",
            "url": "https://www.xingchencinema.com"
          }
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map((faq) => ({
            "@type": "Question",
            "name": faq.q,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.a
            }
          }))
        })}
      </script>

      <Footer />
    </>
  );
}